import React, { useEffect, useState, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import Header2 from "../../components/header/Header2";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { useParams, Link, useNavigate } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import Breadcrumb from "../../components/breadcrumb";
import StepProgress from "../../components/StepProgress";
import { createPortal } from "react-dom";

Scheduler.propTypes = {};

function Scheduler(props) {
  const [toggle, setToggle] = useState({ key: "", status: false });
  const [isShowMobile, setShowMobile] = useState(false);
  const navigate = useNavigate();

  const handleToggle = (key) => {
    if (toggle.key === key) setToggle({ status: false });
    else setToggle({ status: true, key });
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({ live: false });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
  const [categoriesnew2, setCategoriesnew2] = useState([]);

  const [bookingLoading, setBookingLoading] = useState(false);
  const [bookingError, setBookingError] = useState(null);
  const [bookingSuccess, setBookingSuccess] = useState(null);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
    fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort");
      setCategories(res.data);
    } catch {}
  };
  const fetchCategoriesnew = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort");
      setCategoriesnew(res.data);
    } catch {}
  };
  const fetchCategoriesnew1 = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort");
      setCategoriesnew1(res.data);
    } catch {}
  };
  const fetchCategoriesnew2 = async () => {
    try {
      const res = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort");
      setCategoriesnew2(res.data);
    } catch {}
  };

  const { bookingId } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [booking, setBooking] = useState(null);
  const [astrologer, setAstrologer] = useState(null);
  const [plan, setPlan] = useState(null);
  const [astrobase, setAstrobase] = useState(null);
  const [timeRanges, setTimeRanges] = useState([]);
  const [bookedRanges, setBookedRanges] = useState([]);
  const [generatedSlots, setGeneratedSlots] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(0);
  const API_BASE = "https://adhigyanam-e92bf1bbbdb1.herokuapp.com";
  const tabRefs = useRef([]);
  const tabListRef = useRef(null);
  const [reservingId, setReservingId] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);

  // ---------- helpers ----------
  const tryGet = async (paths = []) => {
    for (let p of paths) {
      try {
        const url = p.startsWith("http") ? p : `${API_BASE}${p}`;
        const res = await axios.get(url);
        if (res && (res.status === 200 || res.status === 201) && res.data)
          return res.data;
      } catch {}
    }
    return null;
  };

  const hhmmToMinutes = (hhmm) => {
    if (!hhmm) return null;
    const [hh, mm] = hhmm.split(":").map((s) => parseInt(s, 10));
    if (Number.isNaN(hh) || Number.isNaN(mm)) return null;
    return hh * 60 + mm;
  };
  const minutesToHHMM = (mins) => {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
  };
  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };
  const toISODate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };


const isSameDay = (d1, d2) =>
  d1.getFullYear() === d2.getFullYear() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getDate() === d2.getDate();

const isPastSlot = (slotISO, dayDate) => {
  if (!slotISO || !dayDate) return false;
  const now = new Date();
  return isSameDay(dayDate, now) && new Date(slotISO) <= now;
};



 // Replace existing combineDateTimeISO
const combineDateTimeISO = (dateObj, hhmm) => {
  // dateObj is a Date instance representing local date (the day we selected)
  // hhmm is "HH:MM" in local time (what user sees)
  const [hh, mm] = hhmm.split(":").map((n) => parseInt(n, 10));
  // Create a Date object in local timezone for that date & time:
  const localDate = new Date(
    dateObj.getFullYear(),
    dateObj.getMonth(),
    dateObj.getDate(),
    hh,
    mm,
    0,
    0
  );
 // Return local time in ISO-like format (without converting to UTC)
const pad = (n) => String(n).padStart(2, "0");
return `${localDate.getFullYear()}-${pad(localDate.getMonth() + 1)}-${pad(localDate.getDate())}T${pad(localDate.getHours())}:${pad(localDate.getMinutes())}:${pad(localDate.getSeconds())}`;
};

const normalizeServerDatetime = (dtStr) => {
  if (!dtStr || typeof dtStr !== "string") return null;

  const value = dtStr.trim();

  // Ignore invalid MySQL zero dates
  if (value.startsWith("0000-00-00")) {
    return null;
  }

  /*
   * IMPORTANT:
   * All scheduler times are treated as LOCAL wall-clock times.
   *
   * Example:
   * 2026-08-09T20:00:00.000Z
   *
   * becomes:
   * 2026-08-09T20:00:00
   *
   * We intentionally do NOT convert the Z value from UTC to IST.
   */

  // ISO datetime with Z
  const isoZMatch = value.match(
    /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})(?:\.\d+)?Z$/
  );

  if (isoZMatch) {
    return `${isoZMatch[1]}T${isoZMatch[2]}`;
  }

  // ISO datetime without timezone
  const isoLocalMatch = value.match(
    /^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})(?::(\d{2}))?/
  );

  if (isoLocalMatch) {
    return `${isoLocalMatch[1]}T${isoLocalMatch[2]}:${
      isoLocalMatch[3] || "00"
    }`;
  }

  // MySQL DATETIME
  const mysqlMatch = value.match(
    /^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})(?::(\d{2}))?$/
  );

  if (mysqlMatch) {
    return `${mysqlMatch[1]}T${mysqlMatch[2]}:${
      mysqlMatch[3] || "00"
    }`;
  }

  return null;
};

  const rangesOverlap = (aStart, aEnd, bStart, bEnd) => {
  // Force all comparisons to UTC milliseconds
  const a1 = new Date(aStart).getTime();
  const a2 = new Date(aEnd).getTime();
  const b1 = new Date(bStart).getTime();
  const b2 = new Date(bEnd).getTime();

  return !(a2 <= b1 || a1 >= b2);
};

  // ----- days for tabs (next 7 days, starting from tomorrow) -----
  const days = useMemo(() => {
    const today = new Date();
    // const tomorrow = addDays(today, 1);
    return Array.from({ length: 9 }).map((_, i) => addDays(today, i));
  }, []);
  const fmtTabLabel = (date) => {
    const optsDay = { weekday: "short" };
    const optsDate = { month: "short", day: "numeric" };
    const dShort = new Intl.DateTimeFormat("en-US", optsDay).format(date);
    const dDate = new Intl.DateTimeFormat("en-US", optsDate).format(date);
    return `${dShort} • ${dDate}`;
  };

  // ---------- fetch booking & related ----------
  useEffect(() => {
    if (!bookingId) return;
    const fetchAll = async () => {
      setLoading(true);
      setError(null);
      try {
        const bookingPaths = [
          `/bookingdetails/${bookingId}`,
          `/booking_details/${bookingId}`,
          `/booking/${bookingId}`,
          `/bookingdetails?id=${bookingId}`,
        ];
        const bookingData = await tryGet(bookingPaths);
        if (!bookingData) {
          setError("Booking not found");
          setLoading(false);
          return;
        }
        const bookingRow = Array.isArray(bookingData)
          ? bookingData[0] || null
          : bookingData;
        setBooking(bookingRow);

        const astrologerId =
          bookingRow?.AstrologerId ??
          bookingRow?.astrologerId ??
          bookingRow?.AstrologerID;
        const planId =
          bookingRow?.PlanId ??
          bookingRow?.planId ??
          bookingRow?.PlanID;

        if (astrologerId) {
          const astroData = await tryGet([
            `/astrologer/${astrologerId}`,
            `/astrologers/${astrologerId}`,
          ]);
          const astroRow = Array.isArray(astroData)
            ? astroData[0] || null
            : astroData;
          setAstrologer(astroRow);
        }

        if (planId) {
          const planData = await tryGet([
            `/astroplans/${planId}`,
            `/astroplan/${planId}`,
          ]);
          const planRow = Array.isArray(planData)
            ? planData[0] || null
            : planData;
          setPlan(planRow);

          const acat3id =
            planRow?.acat3id ??
            planRow?.Acat3id ??
            planRow?.acat3Id;
          if (acat3id) {
            const baseData = await tryGet([
              `/astrobase/${acat3id}`,
              `/astro_base/${acat3id}`,
            ]);
            const baseRow = Array.isArray(baseData)
              ? baseData[0] || null
              : baseData;
            setAstrobase(baseRow);
          }
        }
        setLoading(false);
      } catch (err) {
        console.error("Scheduler fetch error:", err);
        setError("An error occurred while fetching scheduler data");
        setLoading(false);
      }
    };
    fetchAll();
  }, [bookingId]);

  // ----- fetch provider time ranges -----
  useEffect(() => {
    const loadProviderRanges = async () => {
      if (!astrologer) return;
      const astroId =
        astrologer.Id ?? astrologer.id ?? astrologer.Aid ?? astrologer.Aid;
      const ctype = (astrologer.Ctype ?? astrologer.ctype ?? "").toLowerCase();

      try {
        let res = null;

        // 🧭 Contractual astrologers — usually multiple ranges
        if (ctype === "contractual" || ctype === "contract" || ctype === "contractarual") {
          res = await tryGet([
            `/astrologer_slots/${astroId}`,
            `/astrologer/${astroId}/slots`,
            `/astrologer_slots?astrologerId=${astroId}`
          ]);

          if (res && Array.isArray(res) && res.length > 0) {
            const ranges = res
              .map((r) => ({
                start:
                  (r.start_time || r.start || r.Cintime || "").slice(0, 5),
                end: (r.end_time || r.end || r.Couttime || "").slice(0, 5),
              }))
              .filter((x) => x.start && x.end);
            console.log("Fetched contractual ranges:", ranges);
            setTimeRanges(ranges);
            return;
          }
        }

        // 🧭 Permanent astrologers — single object with Cintime/Couttime
        res = await tryGet([
          `/slots/${astroId}`,
          `/slots?astrologerId=${astroId}`,
          `/provider_slots/${astroId}`,
        ]);

       if (res) {
  // Always normalize to an array
  const rows = Array.isArray(res) ? res : [res];

  const ranges = rows
    .map((row) => {
      const cintime = (row?.Cintime || row?.cintime || row?.start_time || "")
        .toString()
        .slice(0, 5);

      const couttime = (row?.Couttime || row?.couttime || row?.end_time || "")
        .toString()
        .slice(0, 5);

      if (!cintime || !couttime) return null;

      return {
        start: cintime,
        end: couttime,
      };
    })
    .filter(Boolean); // remove nulls safely

  if (ranges.length > 0) {
    console.log("Fetched permanent ranges:", ranges);
    setTimeRanges(ranges);
    return;
  }
}

        console.warn("No provider slot ranges found for astrologer", astroId);
        setTimeRanges([]);
      } catch (err) {
        console.error("Error loading provider ranges:", err);
        setTimeRanges([]);
      }
    };

    loadProviderRanges();
  }, [astrologer]);

  // ----- fetch already booked/confirmed slots -----
// useEffect(() => {
//   const loadBookedSlots = async () => {
//     if (!astrologer) return;
//     const astroId = astrologer.Id ?? astrologer.id;
//     try {
//       const res = await axios.get(`${API_BASE}/api/astrologer/${astroId}/booked-slots`);
//       if (Array.isArray(res.data)) {
//         const normalized = res.data.map((b) => ({
//           ...b,
//           start: normalizeServerDatetime(b.start || b.start_datetime || b.start_time),
//           end: normalizeServerDatetime(b.end || b.end_datetime || b.end_time),
//         })).filter(x => x.start && x.end);
//         setBookedRanges(normalized);
//         console.group("✅ Loaded booked slots normalized");
// console.table(normalized);
// console.groupEnd();
//       } else {
//         setBookedRanges([]);
//       }
//     } catch (err) {
//       console.error("❌ Error fetching booked slots:", err);
//       setBookedRanges([]);
//     }
//   };

//   loadBookedSlots();
// }, [astrologer]);

// useEffect(() => {
//   const interval = setInterval(() => {
//     if (astrologer) {
//       axios.get(`${API_BASE}/api/astrologer/${astrologer.Id}/booked-slots`)
//         .then(res => setBookedRanges(res.data || []))
//         .catch(() => {});
//     }
//   }, 30000); // refresh every 30 seconds

//   return () => clearInterval(interval);
// }, [astrologer]);

// useEffect(() => {
//   if (!astrologer) return;

//   const astroId =
//     astrologer.Id ??
//     astrologer.id ??
//     astrologer.Aid ??
//     astrologer.aid;

//   if (!astroId) return;

//   const loadBookedSlots = async () => {
//     try {
//       const res = await axios.get(
//         `${API_BASE}/api/astrologer/${astroId}/booked-slots`
//       );

//       if (!Array.isArray(res.data)) {
//         setBookedRanges([]);
//         return;
//       }

//       const normalized = res.data
//         .map((b) => ({
//           ...b,

//           start: normalizeServerDatetime(
//             b.start ??
//             b.start_datetime ??
//             b.start_time
//           ),

//           end: normalizeServerDatetime(
//             b.end ??
//             b.end_datetime ??
//             b.end_time
//           ),
//         }))
//         .filter((x) => x.start && x.end);

//       console.group("✅ Loaded booked + blocked ranges");
//       console.table(normalized);
//       console.groupEnd();

//       setBookedRanges(normalized);

//     } catch (err) {
//       console.error("❌ Error fetching booked/blocked slots:", err);
//       setBookedRanges([]);
//     }
//   };

//   // Initial load
//   loadBookedSlots();

//   // Refresh every 30 seconds
//   const interval = setInterval(loadBookedSlots, 30000);

//   return () => clearInterval(interval);
// }, [astrologer]);

useEffect(() => {
  if (!astrologer) return;

  const astroId =
    astrologer.Id ??
    astrologer.id ??
    astrologer.Aid ??
    astrologer.aid;

  if (!astroId) return;

  let isMounted = true;

  const loadBookedSlots = async () => {
    try {
      const res = await axios.get(
        `${API_BASE}/api/astrologer/${astroId}/booked-slots`,
        {
          // Prevent browser/proxy from serving an old response
          params: {
            _t: Date.now(),
          },
        }
      );

      if (!isMounted) return;

      if (!Array.isArray(res.data)) {
        setBookedRanges([]);
        return;
      }

      const normalized = res.data
        .map((b) => ({
          ...b,

          start: normalizeServerDatetime(
            b.start ??
            b.start_datetime ??
            b.start_time
          ),

          end: normalizeServerDatetime(
            b.end ??
            b.end_datetime ??
            b.end_time
          ),
        }))
        .filter((x) => x.start && x.end);

      console.group("🔄 Loaded booked + blocked ranges");
      console.table(normalized);
      console.groupEnd();

      setBookedRanges(normalized);

    } catch (err) {
      if (isMounted) {
        console.error(
          "❌ Error fetching booked/blocked slots:",
          err
        );
      }
    }
  };

  // Load immediately when astrologer becomes available
  loadBookedSlots();

  // 🔄 Refresh every 15 seconds
  const interval = setInterval(() => {
    loadBookedSlots();
  }, 15000);

  return () => {
    isMounted = false;
    clearInterval(interval);
  };
}, [astrologer]);

  // ----- Generate slots (corrected: endTime visible + display all timing parts) -----
// ----- Generate Slots (supports multiple permanent slots + overnight slots) -----
useEffect(() => {
  if (!timeRanges?.length || !plan) {
    setGeneratedSlots({});
    return;
  }

  const userTime = Number(plan?.Stime || 0);
  const bufferTime = Number(plan?.Btime || 0);
  const coolingTime = Number(plan?.Ctime || 0);

  if (
    !Number.isFinite(userTime) ||
    !Number.isFinite(bufferTime) ||
    !Number.isFinite(coolingTime) ||
    userTime <= 0
  ) {
    setGeneratedSlots({});
    return;
  }

  const totalDuration = userTime + bufferTime + coolingTime;

  const slotsByDay = {};

  const normalizeMinutes = (mins) => {
    mins %= 1440;
    if (mins < 0) mins += 1440;
    return mins;
  };

  const createDateTime = (baseDate, minutesFromMidnight) => {
    const d = new Date(baseDate);

    while (minutesFromMidnight >= 1440) {
      d.setDate(d.getDate() + 1);
      minutesFromMidnight -= 1440;
    }

    while (minutesFromMidnight < 0) {
      d.setDate(d.getDate() - 1);
      minutesFromMidnight += 1440;
    }

    const hh = Math.floor(minutesFromMidnight / 60);
    const mm = minutesFromMidnight % 60;

    d.setHours(hh, mm, 0, 0);

    const pad = (n) => String(n).padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
      d.getSeconds()
    )}`;
  };

  days.forEach((day) => {
    const key = toISODate(day);

    slotsByDay[key] = [];

    timeRanges.forEach((range) => {
      let startMinute = hhmmToMinutes(range.start);
      let endMinute = hhmmToMinutes(range.end);

      if (startMinute == null || endMinute == null) return;

      const overnight = endMinute <= startMinute;

      if (overnight) {
        endMinute += 1440;
      }

      let current = startMinute;

      while (current + userTime <= endMinute) {
        const consultEnd = current + userTime;
        const blockEnd = current + totalDuration;

        if (blockEnd > endMinute) break;

        const startISO = createDateTime(day, current);
        const consultEndISO = createDateTime(day, consultEnd);
        const blockEndISO = createDateTime(day, blockEnd);

        let status = "available";

        const now = new Date();

        if (new Date(startISO) <= now) {
          status = "expired";
        }

     if (status === "available") {
  const slotStart = new Date(startISO).getTime();
  const slotEnd = new Date(blockEndISO).getTime();

  for (const b of bookedRanges) {
    if (!b.start || !b.end) continue;

    const bookedStart = new Date(b.start).getTime();
    const bookedEnd = new Date(b.end).getTime();

    if (
      !Number.isFinite(bookedStart) ||
      !Number.isFinite(bookedEnd)
    ) {
      continue;
    }

    if (
      slotStart < bookedEnd &&
      slotEnd > bookedStart
    ) {
      status = "booked";
      break;
    }
  }
}

        slotsByDay[key].push({
          startHHMM: minutesToHHMM(normalizeMinutes(current)),
          endHHMM: minutesToHHMM(normalizeMinutes(blockEnd)),
          endHHMMnew: minutesToHHMM(normalizeMinutes(consultEnd)),

          startISO,
          endISO: consultEndISO,
          blockEndISO,

          status,

          userTime,
          bufferTime,
          coolingTime,

          totalTime: totalDuration,

          planName: plan?.Named || "Custom Plan",
        });

        // keep your rolling 20 minute intervals
        current += 20;

        if (slotsByDay[key].length > 3000) break;
      }
    });
  });

  console.log("Generated slots:", slotsByDay);

  setGeneratedSlots(slotsByDay);

}, [timeRanges, bookedRanges, plan, days]);

// ---------------------------------------------------------
// Keep selected slot after refresh, but clear it if the slot
// has become booked / blocked / expired.
// ---------------------------------------------------------
useEffect(() => {
  if (!selectedSlot?.startISO) return;

  const selectedStartISO = selectedSlot.startISO;

  // Find the freshly generated version of the selected slot
  const latestSlot = Object.values(generatedSlots)
    .flat()
    .find((slot) => slot.startISO === selectedStartISO);

  // Slot no longer exists in the refreshed slot list
  if (!latestSlot) {
    setSelectedSlot(null);
    return;
  }

  // Slot has become booked, expired, or otherwise unavailable
  if (
    latestSlot.status !== "available" ||
    new Date(latestSlot.startISO) <= new Date()
  ) {
    console.log(
      "⚠️ Selected slot is no longer available. Clearing selection:",
      latestSlot
    );

    setSelectedSlot(null);
    return;
  }

  // Slot is still available.
  // Replace the old selected object with the freshly generated one.
  // This keeps all current status/timing information up to date.
  setSelectedSlot((current) => {
    if (!current) return latestSlot;

    if (
      current.startISO === latestSlot.startISO &&
      current.status === latestSlot.status
    ) {
      return latestSlot;
    }

    return latestSlot;
  });

}, [generatedSlots]);


useEffect(() => {
  const interval = setInterval(() => {
    const now = new Date();

    setGeneratedSlots((prev) => {
      if (!prev) return prev;

      const todayKey = toISODate(new Date());
      const todaySlots = prev[todayKey];
      if (!todaySlots) return prev;

      let selectedBecameExpired = false;

      const updatedTodaySlots = todaySlots.map((s) => {
        if (
          s.status === "available" &&
          new Date(s.startISO) <= now
        ) {
          // Check if this expired slot was selected
          if (selectedSlot?.startISO === s.startISO) {
            selectedBecameExpired = true;
          }
          return { ...s, status: "expired" };
        }
        return s;
      });

      // 🔥 IMPORTANT: unselect slot if it expired
      if (selectedBecameExpired) {
        setSelectedSlot(null);
      }

      return {
        ...prev,
        [todayKey]: updatedTodaySlots,
      };
    });
  }, 15000);

  return () => clearInterval(interval);
}, [selectedSlot]);


  // UI behavior
  const handleTabSelect = (index) => {
    setSelectedIndex(index);
  };

const slotCard = (status, isSelected) => ({
  padding: "10px 12px",
  borderRadius: 8,
  paddingBottom: "15px",
  border:
    status === "expired"
      ? "1px solid #ddd"
      : isSelected
      ? "2px solid #14a077"
      : status === "booked"
      ? "1px solid #ffd8d8"
      : "1px solid #e6e6e6",
  background:
    status === "expired"
      ? "#f5f5f5"
      : status === "booked"
      ? "#fff6f6"
      : isSelected
      ? "#e7f7f1"
      : "#ffffff",
  color: status === "expired" ? "#999" : "#000",
  opacity: status === "expired" ? 0.6 : 1,
  cursor:
    status === "available"
      ? "pointer"
      : "not-allowed",
});
  const slotTimeStyle = { fontWeight: 700, fontSize: 14, marginTop:"-5px" };
  const slotMeta = { fontSize: 12, color: "#555", marginTop: "-7px" };

  const reserveSlot = async ({
  startISO,
  endISO,
  slotStartHHMM,
  slotEndHHMM,
}) => {
  if (!booking || !astrologer) {
    alert("Missing booking or astrologer data.");
    return;
  }
  const now = new Date();

if (
  !selectedSlot ||
  selectedSlot.status !== "available" ||
  new Date(selectedSlot.startISO) <= now
) {
  alert("Selected slot is no longer available. Please choose another slot.");
  setSelectedSlot(null);
  setReservingId(null);
  return;
}

  try {
    setReservingId("pending");

   // Helper to convert ISO → local MySQL DATETIME string
const toMySQLLocal = (isoStr) => {
  const d = new Date(isoStr);
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
};

const payload = {
  bookingId: booking.Id ?? booking.id,
  astrologerId: astrologer.Id ?? astrologer.id,
  planId: plan?.Id ?? null,
  start_datetime: toMySQLLocal(selectedSlot.startISO),
  end_datetime: toMySQLLocal(selectedSlot.blockEndISO),
  display_start: selectedSlot.startHHMM,
  display_end: selectedSlot.endHHMMnew,
  user_time: selectedSlot.userTime,
  buffer_time: selectedSlot.bufferTime,
  cooling_time: selectedSlot.coolingTime,
  total_time: selectedSlot.totalTime,
};

    console.log("📦 Reserve payload:", payload);

    const res = await axios.post(`${API_BASE}/reserve-slot`, payload);

    if (res && res.data && (res.data.reservationId || res.data.insertId)) {
      const reservationId =
        res.data.reservationId ?? res.data.insertId;

      // ✅ Category-based redirection logic
      const category = booking.Category?.trim?.() ?? "";
      let redirectRoute = `/userdetails/${reservationId}`; // default

      const categoryRoutes = {
        "Personalised Consultation": `/userdetails_pc/${reservationId}`,
        "Married Life Analysis": `/userdetails_mla/${reservationId}`,
        "Match Making": `/userdetails_mm/${reservationId}`,
       "Child Name Analysis": `/userdetails_cna/${reservationId}`,
       "Hand Made Kundali Report": `/userdetails_hmkr/${reservationId}`,
       "Business Partnership & Compatibility Analysis": `/userdetails_bp/${reservationId}`,
       "Tarot Card Reading": `/userdetails_tcr/${reservationId}`,
       "Numerology": `/userdetails_n/${reservationId}`,
       "Vastu Analysis": `/userdetails_va/${reservationId}`,
       "Palmistry": `/userdetails_p/${reservationId}`,
       "Face Reading": `/userdetails_fr/${reservationId}`,
        "Handwriting Analysis": `/userdetails_ha/${reservationId}`,
         "Signature Analysis": `/userdetails_sa/${reservationId}`,
         "Birth Time Rectification": `/userdetails_btr/${reservationId}`,
      };

      if (categoryRoutes[category]) {
        redirectRoute = categoryRoutes[category];
      }

      navigate(redirectRoute);
    } else {
      setReservingId(null);
      alert("Reservation created but response malformed.");
    }
  } catch (err) {
    setReservingId(null);
    console.error("Reserve slot error:", err);
    alert(err.response?.data?.message || "Failed to reserve slot. Try again.");
  }
};

  // keyboard handler to allow Enter/Space to select
  const handleSlotKey = (e, slot) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
     if (slot.status !== "available") return;
setSelectedSlot(slot);
    }
  };
 
const canReserveSelectedSlot =
  selectedSlot &&
  selectedSlot.status === "available" &&
  new Date(selectedSlot.startISO) > new Date();

// Floating button that renders into document.body (portal)
const FloatingReservePortal = ({ selectedSlot, reservingId, onReserve }) => {
  if (!selectedSlot) return null;

  const handleClick = () => {
    if (reservingId === "pending") return;
    onReserve();
  };

  const wrapperStyle = {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 40,
    zIndex: 99999,
    display: "flex",
    justifyContent: "center",
    pointerEvents: "none", // let children control clicks
  };

  const innerStyle = {
    pointerEvents: "auto", // allow clicks
    // width: "100%",
    // maxWidth: 320,
    // padding: "12px",
    // margin: "0 12px",
    display: "flex",
    justifyContent: "center",
    // background: "linear-gradient(to top, rgba(255,255,255,0.96) 50%, rgba(255,255,255,0))",
    borderRadius: 12,
    boxShadow: "0 -6px 18px rgba(0,0,0,0.08)",
    backdropFilter: "blur(6px)",
  };

  const btnStyle = {
    padding: "12px 31px",
    border: "1px solid #14a077",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    borderRadius: "4px",
    display: "block",
    color: "rgb(255, 255, 255)",
    backgroundColor: "#14a077",
    textTransform: "none",
    cursor: reservingId === "pending" ? "not-allowed" : "pointer",
  };

  return createPortal(
    <div style={wrapperStyle} aria-hidden={false}>
      <div style={innerStyle}>
        <button
          type="button"
          onClick={handleClick}
          disabled={reservingId === "pending"}
          style={btnStyle}
        >
          {reservingId === "pending" ? "Reserving Slot..." : "Next: Add Booking Details"}
        </button>
      </div>
    </div>,
    document.body
  );
};


  return (
    <>
      <Helmet>
        <title>Select a Time Slot - Adhigyanam</title>
      </Helmet>
  <div className="menu-mobile-popup">
             <div className="modal-menu__backdrop" onClick={handleMobile}></div>
             <div className="widget-filter">
               <div className="mobile-header">
                 <div id="logo" className="logo">
                   <Link to="/home">
                     <img className="site-logo" src={logo} alt="Image" />
                   </Link>
                 </div>
                 <Link className="title-button-group" onClick={handleMobile}>
                   <i className="icon-close"></i>
                 </Link>
               </div>
     
            <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
               <div
                 className="header-customize-item button"
                 style={{
                   padding: "0px 0px",
                   background: "none",
                   backgroundColor: "#14a077",
                   borderRadius: "4px",
                   fontWeight: "700",
                   fontSize: "16px",
                   lineHeight: "21px",
                   color: "white",
                   borderColor: "transparent",
                   textTransform: "capitalize",
                 }}
               >
                 <Link to="/astroservices" style={{ color: "#ffffff" }}>
                   Consult Now
                 </Link>
               </div>
               <div className="header-customize-item button">
                 <Link to="/login">My Account</Link>
               </div>
     
               <div className="mobile-footer">
                 <div className="icon-infor d-flex aln-center">
                   <div className="icon">
                     <span className="icon-call-calling">
                       <span className="path1"></span>
                       <span className="path2"></span>
                       <span className="path3"></span>
                       <span className="path4"></span>
                     </span>
                   </div>
                   <div className="content">
                     <p>Need help? 24/7</p>
                     <h6>
                       <Link to={`tel:918960708425`}>+91-8960708425</Link>
                     </h6>
                   </div>
                 </div>
                 <p>
                   <b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016
                 </p>
                 <p style={{ marginTop: "15px" }}>
                   <b>Write To Us On</b>:{" "}
                   <Link to={`mailto:sauntesthyam@gmail.com`} style={{ textDecoration: "underline" }}>
                     sauntesthyam@gmail.com
                   </Link>
                   ,{" "}
                   <Link to={`mailto:info@adhigyanam.com`} style={{ textDecoration: "underline" }}>
                     info@adhigyanam.com
                   </Link>
                 </p>
                 <div className="wd-social d-flex aln-center" style={{ marginTop: "15px" }}>
                   <ul className="list-social d-flex aln-center">
                     <li>
                       <Link to="https://www.facebook.com/Adhigyanam">
                         <i className="icon-facebook"></i>
                       </Link>
                     </li>
                     <li>
                       <Link to="https://www.instagram.com/the_vedic_astro">
                         <i className="icon-instagram1"></i>
                       </Link>
                     </li>
                     <li>
                       <Link to="https://x.com/adhigyanam">
                         <i className="icon-twitter"></i>
                       </Link>
                     </li>
                   </ul>
                 </div>
               </div>
             </div>
           </div>
      <Header2 clname="act1" handleMobile={handleMobile} />
      <Breadcrumb title="Select a Time Slot" />
 <StepProgress activeStep={2} />
      <section
        className="testimonials-category-section"
        style={{ paddingTop: "20px", paddingBottom: "20px" }}
      >
        <div className="tf-container">
          <div className="col-md-10" style={{ margin: "auto", textAlign: "center" }}>
            <main>
              {loading && (
                <p style={{ color: "#14A078", fontWeight: "bold" }}>
                  Please Wait! Loading Available Slots...
                </p>
              )}
              {error && <p style={{ color: "crimson" }}>{error}</p>}

              {!loading && !error && booking && (
                <>

                  <h5 style={{ fontSize: "22px", marginTop: "10px" }}>
                    {astrologer?.Named}
                  </h5>
                  <p>
                    <span style={{ color: "#14A078", fontWeight: "bold" }}>
                      {booking.Category}
                    </span>
                  </p>
                  <p>
                    Use the following slot manager to reserve your preferred slot. We offer advance bookings for upto 9 days.<br />
                    <b>Consultation Fee:</b> {booking.TotalPrice}.00 INR
                  </p>

                  {(!plan?.Stime || !plan?.Btime || !plan?.Ctime) && (
                    <div style={{ color: "#666" }}>No slots available.</div>
                  )}

                  {plan?.Stime && plan?.Btime && plan?.Ctime && (
                    <>
                      {Object.keys(generatedSlots).length === 0 && (
                        <div style={{ color: "#666" }}>
                          No slots available.
                        </div>
                      )}

                      {Object.keys(generatedSlots).length > 0 && (
                        <Tabs
                          selectedIndex={selectedIndex}
                          onSelect={handleTabSelect}
                        >
                          {/* --- Responsive tab list (replace your existing TabList / Tab mapping) --- */}
{/* --- Responsive tab list (replace your existing TabList / Tab mapping) --- */}
<style>{`
  /* responsive tweaks for Scheduler tabs */
  .scheduler-tablist {
    -webkit-overflow-scrolling: touch;
   
  }
  .scheduler-tab {
    scroll-snap-align: center;
    box-sizing: border-box;
  }

  /* reduce tab width on small screens */
  @media (max-width: 480px) {
    .scheduler-tab .tab-inner {
      min-width: 88px;
      padding: 8px 10px;
      font-size: 12px;
       scroll-snap-type: x mandatory;
    }
  }

  @media (max-width: 360px) {
    .scheduler-tab .tab-inner {
      min-width: 76px;
      padding: 7px 8px;
      font-size: 11px;
       scroll-snap-type: x mandatory;
    }
  }

  @media (min-width: 768px) {
  .tablist-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  .tablist-wrap::-webkit-scrollbar { display: none; height: 0; }
}

`}</style>

<TabList
  ref={tabListRef}
  className="scheduler-tablist"
  style={{
    display: "flex",
    gap: 8,
    overflowX: "auto",
    padding: "6px 10px",
    whiteSpace: "nowrap",
    scrollbarWidth: "none",         // <-- Firefox: hide scrollbar
    msOverflowStyle: "none",        // <-- IE/Edge: hide scrollbar
    marginBottom: "10px",
    marginTop: "20px",
    WebkitOverflowScrolling: "touch",
  }}
  // ✅ this hides scrollbar for WebKit browsers
  onWheel={(e) => {
    e.currentTarget.style.scrollbarWidth = "none";
  }}
>
<style>
  {`
    .scheduler-tablist::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      background: transparent;
    }
  `}
</style>
  {days.map((d, idx) => {
    const dayKey = toISODate(d);
    const slotCount = generatedSlots[dayKey]?.length || 0;
    const active = idx === selectedIndex;
    return (
      <Tab
      key={idx}
  data-index={idx} 
        className="scheduler-tab"
        style={{
          display: "inline-flex",
          flex: "0 0 auto",           // <-- prevents flex shrinking / wrapping
          alignItems: "center",
          justifyContent: "center",
          padding: "10px 14px",
          borderRadius: 10,
          border: active ? "1px solid #14a077" : "1px solid #e6e6e6",
          background: active ? "#f2f2f2" : "#fff",
          cursor: "pointer",
          minWidth: 120,             // desktop default
          boxShadow: active ? "0 4px 12px rgba(0,123,255,0.08)" : "none",
        }}
      >
        <div className="tab-inner" style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
          <p style={{ fontWeight: 700, margin: 0 }}>{fmtTabLabel(d)}</p>
          <p style={{ fontSize: 12, color: "#666", marginTop: "-4px" }}>{slotCount} slots</p>
        </div>
      </Tab>
    );
  })}
</TabList>

                          {days.map((d, idx) => {
                            const dayKey = toISODate(d);
                            const slots = generatedSlots[dayKey] || [];
                            return (
                              <TabPanel key={idx}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10,
                                  }}
                                >
                                  {slots.length === 0 && (
                                    <div style={{ color: "#666" }}>
                                      No slots for this day.
                                    </div>
                                  )}

                                  {slots.length > 0 && (
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: 10,
                                        justifyContent: "center",
                                        alignItems: "flex-start",
                                        textAlign: "center",
                                      }}
                                    >
                                      {slots.map((s, i) => {
                                        const isSelected = selectedSlot?.startISO === s.startISO;
                                        return (
                                          <div
                                            key={i}
                                            role={s.status === "booked" ? undefined : "button"}
                                            tabIndex={s.status === "booked" ? -1 : 0}
                                            onKeyDown={(e) => handleSlotKey(e, s)}
                                            onClick={() => {
                                              if (s.status !== "booked") {
                                                setSelectedSlot(s);
                                              }
                                            }}
                                            style={slotCard(s.status, isSelected)}
                                            aria-pressed={isSelected}
                                            aria-disabled={s.status === "booked"}
                                          >
                                        <span
  style={{
    fontSize: 12,
    color:
      s.status === "booked"
        ? "#b00020"
        : s.status === "expired"
        ? "#d32f2f" // 🔴 red for expired
        : "#2e7d32",
    fontWeight: 600,
  }}
>
  {s.status === "booked"
    ? "Booked"
    : s.status === "expired"
    ? "Expired"
    : "Available"}
</span>
                                           <p style={slotTimeStyle}>
  {s.startHHMM} — {s.endHHMMnew}
</p>
<p style={slotMeta}>
  <b>Duration</b>: {s.userTime} minutes
  
</p>
<p style={slotMeta}>
 
</p>
                                            {/* a small helper text */}
                                            {/* <div style={{ marginTop: "-6px", fontSize: 13, color: isSelected ? "#0b6b4a" : "#14a077", fontWeight: isSelected ? 700 : 600 }}>
                                              {isSelected ? "Selected" : (s.status === "booked" ? "Slot Unavailable" : "Reserve This Slot")}
                                            </div> */}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}
                                </div>
                              </TabPanel>
                            );
                          })}
                       
                        </Tabs>
                      )}
                    </>
                  )}
                </>
              )}
            </main>
          </div>
        </div>
      </section>
      <style>{`
  @media (max-width: 767.98px) {
    .floating-slot-card {
      display: block !important;
    }
  }
`}</style>
{canReserveSelectedSlot && (
  <div
    className={`floating-slot-card ${reservingId === "pending" ? "disabled" : ""}`}
    style={{
      position: "fixed",
      left: "50%",
      bottom: "20px",
      transform: "translateX(-50%)",
      zIndex: 1500,
      background: "#f6fffb",
      border: "1px solid #bfead2",
      borderRadius: "12px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.12)",
      maxWidth: "360px",
      width: "90%",
      padding: "12px 16px",
      textAlign: "center",
     
    }}
  >
    <div style={{ fontSize: "14px", color: "#111", fontWeight: 600, marginBottom: "8px" }}>
    <b>Selected slot is available!</b><br/>Continue to add your booking details.
     
    </div>
    <button
      onClick={() =>
        reserveSlot({
          startISO: selectedSlot.startISO,
          endISO: selectedSlot.endISO,
          slotStartHHMM: selectedSlot.startHHMM,
          slotEndHHMM: selectedSlot.endHHMMnew,
        })
      }
      disabled={reservingId === "pending"}
      style={{
       padding: "12px 31px",
    border: "1px solid #14a077",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "26px",
    borderRadius: "4px",
    display: "block",
    color: "rgb(255, 255, 255)",
    textTransform: "none",
    wudth:"auto",
    margin:"auto",
        backgroundColor: reservingId === "pending" ? "#9fcfba" : "#14a077",
        cursor: reservingId === "pending" ? "not-allowed" : "pointer",
      }}
    >
      {reservingId === "pending"
        ? "Reserving Slot..."
        : "Next: Add Booking Details"}
    </button>
  </div>
)}
      <Footer />
      {/* <Gotop /> */}
    </>
  );
}

export default Scheduler;